import { useTranslations as useIntlTranslations } from 'use-intl';

import { TranslateFunction, TranslateKey } from '../i18n/types/next-intl';

export function useTranslations<NestedKey extends TranslateKey = never>(
  namespace?: NestedKey
): TranslateFunction<NestedKey> {
  return useIntlTranslations(namespace) as never;
}
